// extracted by mini-css-extract-plugin
export default {"shipment-table__wrapper":"CompletedSalesOrderTable_shipment-table__wrapper__eldZR","shipment-table":"CompletedSalesOrderTable_shipment-table__L6ipm"};